<template>
    <li class="c-thumbnail-list__item c-thumbnail-list__item-4">
        <a :href="item.url">
            <div class="c-thumbnail-list__img search_list">
                <div class="thumbnail_wrapper">
                    <webp-picture :webp="item.thumbnail_webp_path">
                        <img :src="item.thumbnail_path" alt="" loading="lazy">
                    </webp-picture>
                    <div v-if="item.has_discount" class="sales_sash">{{ item.discount_string }}</div>
                </div>
            </div>
            <div class="c-thumbnail-list__text">
                <p class="c-bookname" v-for="(talent, i) in item.talents" :key="i">{{ talent.name }}</p>
                <p class="c-booktitle wpb_title">{{ item.has_regular_title ? item.wpb_parts[1] + item.wpb_parts[4] : "" }}</p>
                <p class="c-booktitle text-truncate2">{{ $filters.truncate(item.item_title, 21, "...") }}</p>
                <template v-if="from_detail === false">
                    <p v-if="item.has_discount == false" class="c-thumbnail-list__price c-black">
                        <span class="u-bold">￥{{ item.item_price }}</span>（税込）
                    </p>
                    <p v-else class="c-thumbnail-list__price">
                        <span class="u-bold">￥{{ item.item_price }}</span>（税込）
                        <span class="c-label-off">{{ item.item_discount_detail }}</span>
                    </p>
                    <div class="c-thumbnail-list__icon">
                        <div class="c-label-new" v-if="item.is_new == true">New</div>
                        <div class="c-label-photobook">{{ item.category }}</div>
                    </div>
                </template>
            </div>
        </a>
        <div v-if="item.web_free_url != null" class="c-btn-trial">
            <a :href="item.web_free_url" target="_blank">立ち読み</a>
        </div>
    </li>
</template>

<script>
    import routeMixin from '../../mixins/route.js';

    export default {
        props: [
            'route_list',
            'item',
            'from_detail',
        ],
        mixins: [routeMixin],
        data() {
            return {
            }
        },
        methods: {
            // 商品価格を3桁区切り
            formatPrice(price) {
                const formatter = new Intl.NumberFormat('ja-JP');
                return formatter.format(price);
            },
        },

    }
</script>

<style lang="scss" scoped>
</style>
